/* tslint:disable */

// AUTO-GENERATED FILE. DO NOT EDIT.

export const CURRENT_REVISION = "36b46e83d6e8f9e94f4bf7846a8c2c66ed7dbe9d";
